import http from "./httpService";
import { StreamApiBase } from "../utils/constants";
import auth from "./authService";
import { getCurrentUser } from "./authService";
import { RubbleTicket } from "../interface/api/RubbleTicket";
import { GenerateTicketsPayload } from "../interface/api/GenerateTicketsPayload";
import { SearchPayload } from "../interface/api/SearchPayload";
import { RubbleBulkUpdatePayload } from "../interface/api/RubbleBulkUpdatePayload";
import { RubbleBulkClearPayload } from "../interface/api/RubbleBulkClearPayload";
import { GenerateExcelExportPayload } from "../interface/api/GenerateExcelExportPayload";
import { GenerateReportPayload } from "../interface/api/GenerateReportPayload";

http.setJwt(auth.getJwt());

const BASE = StreamApiBase["rubble"];

export const getAll = () => {
  return http.get(`${BASE}/all`);
};

export const getLatest = () => {
  return http.get(`${BASE}/latest`);
};

// Today's received loads (full table) for the Received toggle.
export const getReceivedToday = () => {
  return http.get(`${BASE}/received`);
};

// Today's active loads (loaded today, not received) for the Active toggle.
export const getActiveToday = () => {
  return http.get(`${BASE}/active`);
};

export const getTicket = (id: number | string) => {
  const jwt = getCurrentUser();
  if (jwt) {
    return http.get(`${BASE}/${id}`);
  } else {
    const urlParams = new URLSearchParams(window.location.search);
    const hash = urlParams.get("hash");
    return http.get(`${BASE}/${id}/${hash}`);
  }
};

export const getTicketHash = (id: number) => {
  return http.get(`${BASE}/${id}/hash`);
};

export const generateTickets = (payload: GenerateTicketsPayload) => {
  return http.post(`${BASE}/generate`, payload);
};

export const searchTickets = (payload: SearchPayload) => {
  return http.post(`${BASE}/search`, payload);
};

export const saveTicket = (ticket: RubbleTicket) => {
  const jwt = getCurrentUser();
  if (jwt) {
    return http.put(`${BASE}/edit`, ticket);
  } else {
    const urlParams = new URLSearchParams(window.location.search);
    const hash = urlParams.get("hash");
    return http.put(`${BASE}/${ticket.id}/${hash}/edit`, ticket);
  }
};

// Receives a load with the receive dialog's edits. The server applies only the fields
// receiving may change, so Time Loaded and Time Received are ignored if present.
export const receiveTicket = (ticket: RubbleTicket) => {
  return http.post(`${BASE}/receive/${ticket.id}`, ticket);
};

export const unreceiveTicket = (id: number) => {
  return http.post(`${BASE}/unreceive/${id}`, {});
};

export const deleteTicket = (id: number | string) => {
  return http.delete(`${BASE}/${id}`);
};

export const checkBulkUpdate = (payload: RubbleBulkUpdatePayload) => {
  return http.post(`${BASE}/bulk/check`, payload);
};

export const bulkUpdate = (payload: RubbleBulkUpdatePayload) => {
  return http.post(`${BASE}/bulk/update`, payload);
};

export const bulkClear = (payload: RubbleBulkClearPayload) => {
  return http.post(`${BASE}/bulk/clear`, payload);
};

export const getReportingTickets = (payload: GenerateReportPayload) => {
  return http.post(`${BASE}/report`, payload);
};

export const exportTicketsExcel = (payload: GenerateExcelExportPayload) => {
  return http.post(`${BASE}/generate/excel`, payload);
};

export const getTicketLogs = (id: number | string) => {
  return http.get(`${BASE}/logs/${id}`);
};

export default {
  getAll,
  getLatest,
  getReceivedToday,
  getActiveToday,
  getTicket,
  getTicketHash,
  generateTickets,
  searchTickets,
  saveTicket,
  receiveTicket,
  unreceiveTicket,
  deleteTicket,
  checkBulkUpdate,
  bulkUpdate,
  bulkClear,
  getReportingTickets,
  exportTicketsExcel,
  getTicketLogs,
};
